import { cn } from '@/lib/utils';

export default function H3({
    children,
    className,
    weight = 'bold',
    color = 'black',
}: {
    children: string | React.ReactNode;
    className?: string;
    weight?: 'regular' | 'bold';
    color?: 'blue' | 'white' | 'black' | 'brand-white';
}) {
    return (
        <h3
            className={cn(
                color === 'black' && 'text-black',
                color === 'blue' && 'text-primary',
                color === 'white' && 'text-white',
                color === 'brand-white' && 'text-tofu',
                'uppercase max-lg:text-h4 lg:text-h3 leading-none',
                weight === 'bold' ? 'font-bold' : 'font-normal',
                className,
            )}
        >
            {children}
        </h3>
    );
}
